export default function buildTitheHistory(rawS) {
   return {
      name: rawS._type,
      props: {},
   };
}
